<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <CompBoleto v-if="showBanco" :dialog="dialog" :opts="opts" v-on:close="close()" />
            <PdfView  v-if="showPdf" :email="opts.email" :pdfFile="pdfFile" v-on:close="close()" />
        </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CompBoleto from "./compBoleto.vue";
import PdfView from "./pdfViewer.vue";
import axios from 'axios';
import config from "../../config.json";

export default {
   watch: {
    dialog: function (val) {
      if(val) {
        this.defDestino()
      }
    }
  },
  props: ['dialog', 'opts'],
  components: {
    CompBoleto,
    PdfView
  },
  mounted () {
    this.defDestino()
  },
  data() {
    return {
      showBanco: false,
      showPdf:   false,
      pdfFile:   '',
      notifications: false,
      sound: true,
      widgets: false
    };
  },
  methods : {
      close: function() {
        this.dialog = false
        this.$emit('close', '')
      },
      
      defDestino: async function () {
         this.showBanco = false
         this.showPdf   = false
         
          if ( this.opts.vencido || (!this.opts.pdfBol) ) {
            this.showBanco = true
          } else if ( this.opts.pdfBol ) {
            let pdfOK  = await this.obterPdf(this.opts.pdfBol)
            if ( pdfOK && this.pdfFile ) {
              this.showPdf = true
            } else {
              this.showBanco = true
            }
          } else {
            this.showBanco = true
          }
      },

      obterPdf: async function (objDados) {
        try {
          let api = config.client.api
          let resp = null
          let dataCli = { 
                          'email': this.opts.email,
                          'celSms': '11997294524'
                        }

          if (window.location.toString().toLowerCase().includes(config.client.bkp)) {
            api = config.client.apiBkp
          }

          resp = await axios.post(api + '/pdfBoleto', { objDados, dataCli });
          this.showBanco = false
          this.showPdf = true
          this.pdfFile = resp
          return true
        } catch(err) {
           console.log(`ERRO ${err.message}`)
           return false
        }
      }
  }
};
</script>